/** 座標系：x＝東、y＝上（海抜）、z＝南。単位は m */
export interface Vec2 {
  x: number;
  z: number;
}

export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

export const dist2 = (a: Vec2, b: Vec2): number => Math.hypot(a.x - b.x, a.z - b.z);

/** 点 p と線分 ab の距離と、線分上の位置（0〜1） */
export function distToSegment(
  px: number,
  pz: number,
  ax: number,
  az: number,
  bx: number,
  bz: number,
): { dist: number; t: number } {
  const dx = bx - ax;
  const dz = bz - az;
  const len2 = dx * dx + dz * dz;
  let t = len2 > 0 ? ((px - ax) * dx + (pz - az) * dz) / len2 : 0;
  t = t < 0 ? 0 : t > 1 ? 1 : t;
  const cx = ax + dx * t;
  const cz = az + dz * t;
  return { dist: Math.hypot(px - cx, pz - cz), t };
}

/** 北を 0 とした時計回りの方位（ラジアン）から、水平の単位ベクトル */
export function azimuthToDir(az: number): Vec2 {
  return { x: Math.sin(az), z: -Math.cos(az) };
}

/** 水平ベクトルの方位（北 0、時計回り） */
export function dirToAzimuth(dx: number, dz: number): number {
  return Math.atan2(dx, -dz);
}
